import API from "../components/utils/API";

export default class Contact {
    static sendContact = async (body) => {
        return API.set('/contact', 'POST', body);
    }
}